import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);
bootstrap().catch(err => {
    console.error('Angular Bootstrap Error:', err);
    if (typeof document !== 'undefined') {
        const div = document.createElement('div');
        div.style.cssText = 'position:fixed;top:0;left:0;width:100%;padding:16px;background:#cc0000;color:#fff;font-family:sans-serif;z-index:999999;box-sizing:border-box;word-break:break-all;';
        div.innerHTML = '<h3>App Initialization Failed</h3><p>' + (err && err.message ? err.message : err) + '</p><pre style="white-space:pre-wrap;font-size:11px;">' + (err && err.stack ? err.stack : '') + '</pre>';
        document.body ? document.body.appendChild(div) : document.addEventListener('DOMContentLoaded', () => document.body.appendChild(div));
    }
});

